import { render, staticRenderFns } from "./cambioClienteDevolucion.vue?vue&type=template&id=1c723109"
import script from "./cambioClienteDevolucion.vue?vue&type=script&lang=js"
export * from "./cambioClienteDevolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports